import * as React from "react";
import { FormSubmitHandler, InjectedFormProps, reduxForm } from "redux-form";

import { Product } from "../../../models";
import * as constants from "../constants";
import validate from "../project-form-validation";
import { DropzoneFile } from "../../../components";
import FieldSwitch from "./ProjectInfoFormFieldSwitch";
import AdvancedProjectFields from "./AdvancedProjectFields";
import { ATT_MATRIX_VALS } from "../../Wizard/constants";

export interface ProjectInfoFormProps {
  chosenProduct: Product;
  industryOptions: JSX.Element | JSX.Element[];
  quantityUnit: string;
  isDataLoading: boolean;
  useDefaultDimensions: boolean;
  showAdvanced: boolean;
  initialValues: Partial<ProjectInfoFormValues>;
  onSubmit: FormSubmitHandler<ProjectInfoFormValues>;
  toggleDefDimension: () => void;
  toggleAdvancedFields: () => void;
}

export interface ProjectInfoFormValues {
  industry?: string;
  dimension_width?: string;
  dimension_height?: string;
  dimension_depth?: string;
  page_number?: string;
  primary_color?: string;
  secondary_color?: string;
  title?: string;
  content?: string;
  material?: DropzoneFile[];
  audience?: string;
}

const shouldRenderField = (att: number) =>
  [ATT_MATRIX_VALS.REQ, ATT_MATRIX_VALS.OPT].includes(att);

export interface AugmentedProjectInfoFormProps
  extends InjectedFormProps<ProjectInfoFormValues, ProjectInfoFormProps>,
    ProjectInfoFormProps {}

const InfoForm = (props: AugmentedProjectInfoFormProps) => (
  <form
    className="form-horizontal info-form info-form--header"
    onSubmit={props.handleSubmit}
  >
    <FieldSwitch {...props} shouldRenderField={shouldRenderField} />
    <AdvancedProjectFields {...props} />
  </form>
);

export default reduxForm<ProjectInfoFormValues, ProjectInfoFormProps>({
  form: constants.PROJECT_INFO_FORM,
  enableReinitialize: true,
  keepDirtyOnReinitialize: true,
  validate,
})(InfoForm);



// WEBPACK FOOTER //
// ./src/routes/Step4/components/ProjectInfoForm.tsx